import { render, staticRenderFns } from "./belong.vue?vue&type=template&id=42e7e150&scoped=true"
import script from "./belong.vue?vue&type=script&lang=js"
export * from "./belong.vue?vue&type=script&lang=js"
import style0 from "./belong.vue?vue&type=style&index=0&id=42e7e150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e7e150",
  null
  
)

export default component.exports